<template>
  <div id="feed-main">
    <van-list
      v-model="params.Loading"
      :finished="params.Finished"
      finished-text=""
      @load="onLoad"
    >
      <listItem
        :recipesList="recipesList"
        @handleDetails="handleDetails"
      ></listItem>
      <template v-if="recipesList.length !== 0" #finished>
        <img
          class="icon"
          src="@/assets/images/expertsView/pentagram.png"
          style="width: 9px"
        />
        我们会加油更新的 么么哒~
        <img
          class="icon"
          src="@/assets/images/expertsView/pentagram.png"
          style="width: 9px"
        />
      </template>
    </van-list>
  </div>
</template>

<script>
import listItem from '@/components/contents/babyFeeding/recipes/listItem'
// import minxins from '@/minxs/babyFeeding.js'
import Api from '@/utils/axiosApi/babyFeedingApi'

export default {
  name: 'babyFeed',
  // mixins: [minxins],
  components: {
    listItem,
  },
  data() {
    return {
      crmId: JSON.parse(localStorage.getItem('userInfo'))?.crm_id,
      recipesList: [],
      params: {
        page: 1,
        size: 25,
        total: 0,
        Loading: false, // 是否加载状态
        Finished: false, // 是否加载完成
        Error: false, // 是否加载失败
        finishText: '', // 加载完成文本
      },
    }
  },
  created() {
    this.getFeedLikeList()
    this.$route.meta.xmhh5_bbsp_viewstation = '收藏中辅食tab下'
  },
  methods: {
    initFn() {
      this.params.page = 1
      this.params.size = 25
      this.getFeedLikeList()
    },
    handleDetails(value) {
      sessionStorage.setItem('feedTag', value.tagId)

      // this.$router.push({path: "/babyFeedDetails/" + value.id})
    },
    // 收藏
    // handleCollect(value) {
    //   if (value.collectState) {
    //     const arr = this.recipesList.map(item => item.id)
    //     const ind = arr.indexOf(value.id)
    //     console.log(arr, 'arr')
    //     console.log(ind, 'ind')
    //     // if (ind !== -1) {
    //     //   this.recipesList.splice(ind, 1)
    //     // }
    //   }
    //   console.log(this.recipesList.filter(item => item.id), 'value')
    // },
    getFeedLikeList() {
      Api.feedLikeList(
        {
          crmId: this.crmId,
          page: this.params.page,
          size: this.params.size,
        },
        (res) => {
          if (res.code == 200 && res.data.data) {
            if (this.params.page == 1) {
              this.recipesList = res.data.data
            } else {
              this.recipesList = this.recipesList.concat(res.data.data)
            }
            this.params.total = res.data.total
            if (
              this.params.page >= Math.ceil(res.data.total / this.params.size)
            ) {
              this.params.Finished = true
              this.params.finishText = '——已经到底了哦——'
            } else {
              this.params.page += 1
            }
            if (this.params.page == 1 && res.data.data.length == 0) {
              this.params.finishText = ''
            }

            if (res.data.data.length == 0) {
              this.params.Finished = true
              this.$emit('isEmpty', true)
            }
          } else {
            this.params.Loading = false
            this.params.Error = true
            this.params.Finished = true
            this.$emit('isEmpty', true)
          }
        },
        (err) => {
          console.log(err, '333333')
        }
      )
    },
    onLoad() {
      console.log(21312366)
      setTimeout(() => {
        if (this.recipesList.length) {
          if (this.params.total === this.recipesList.length) {
            this.params.Finished = true
            console.log(213123)
          } else {
            this.getFeedLikeList()
          }
        }
      }, 500)
    },
  },
}
</script>

<style lang="less" scoped>
#feed-main {
  //flex: 1;
  //height: 100%;
  flex-grow: 0;
  flex-shrink: 0;
  //overflow: scroll;
}
</style>
